import React, { useEffect, useRef, useState } from 'react'
import { Button, MetaSeo, JsonLd } from 'components/atoms'
import { GoogleReCaptchaWrapper } from 'components/organisms'
import useUtente from '@hooks/useUtente'
import useTrans from '@hooks/useTrans'
import { isToolbarVisible } from '@utils/index'
import styles from './LandingPage.module.sass'

interface Props {
  pagina: any // PaginaNode
  item?: any
  children: React.ReactNode
  className?: string
  contentClassName?: string
  recaptchaRequired?: boolean
}

const LandingPage = (props: Props) => {
  const {
    pagina,
    item = {},
    children = null,
    className = '',
    contentClassName = '',
    recaptchaRequired = false,
  } = props

  const [scrollY, setScrollY] = useState(0)

  const mainRef = useRef(undefined)
  const { utente } = useUtente()
  const showToolbar = isToolbarVisible(utente)
  const t = useTrans()

  const handleScroll = () => {
    if (window.scrollY > 0) document.body.classList.add('w-scrolled')
    else document.body.classList.remove('w-scrolled')
    if (window.scrollY < scrollY) document.body.classList.add('w-scrollup')
    else document.body.classList.remove('w-scrollup')
    setScrollY(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [scrollY])

  const [Toolbar, setToolbar] = useState<React.JSX.Element>()

  useEffect(() => {
    // carico il componente solo se l'utente ha i permessi
    const loadToolbar = async () => {
      const ToolbarComponent = (await import('components/organisms/Toolbar/Toolbar')).default
      setToolbar(<ToolbarComponent page={pagina} item={item} />)
    }

    if (showToolbar) {
      loadToolbar()
    }
  }, [showToolbar])

  return (
    <GoogleReCaptchaWrapper recaptchaRequired={recaptchaRequired}>
      <div className={styles.pageWrap}>
        <Button
          label={t('Vai al contenuto')}
          onClick={() => {
            mainRef?.current?.focus()
          }}
          className={styles.skipToMain}
        />
        {showToolbar && Toolbar}
        <div className={`${styles.root} page ${className}`}>
          {pagina?.seo && <MetaSeo seo={pagina.seo} hreflangs={pagina.hreflangs} />}

          <div className={`${styles.content} ${contentClassName}`} ref={mainRef} tabIndex={-1}>
            {children}
          </div>
        </div>
      </div>
      <JsonLd type="organization" />
      <JsonLd type="search" />
    </GoogleReCaptchaWrapper>
  )
}

export default LandingPage
